<template>
  <div>
    <section class="hero"> 
      <div class="texts">
        <div class="hero-1">重塑产业信任，让每一次服务都值得托付</div>
        <div class="hero-2">让3亿家庭享受可信赖的数字化装修服务</div>
      </div>
      <img class="hero-bg" src="https://obs.huahuaeco.com/official/aboutTopBg.png" alt="" aria-hidden="true" />
    </section>
    <section id="img-2" class="full-image">
      <div class="about-intro">
        <div class="intro-top">
          <img class="intro-cover" src="https://obs.huahuaeco.com/official/About/huahuaCompany.png" alt="化化平台大楼" />
          <div class="intro-main">
            <p class="intro-en">PLATFORM INTRODUCTION</p>
            <h2 class="intro-title">平台简介</h2>
            <div class="intro-line"></div>
            <p style="font-size: 16px;">化化网是深圳市化化科技有限公司旗下的城乡更新公开履单平台，专注为城市住宅装修、商业空间装修、局改修缮、农村自建房翻新与新建提供一站式保障服务。</p>
            <p style="font-size: 16px;">平台以“先做后付、信息透明、在线履约、平台托底”为核心机制，构建了完善的信用体系与交易保障体系，致力于提升行业信息透明度与信任度，为业主打造安心、省心、可信赖的服务体验。</p>
            <p style="font-size: 16px;">化化网旗下拥有自营装修建房品牌“化化自营”，由具备设计与施工资质的中迈致远建设集团作为核心承担者，为业主提供从设计、施工到交付的全过程服务。化化自营作为平台托底保障的核心承担者，始终恪守不转包、不分包的直营承诺。一线施工团队长期磨合、高度协同；材料统一采购，严控源头品质；工艺执行统一标准，规范全程作业；验收实施统一把关，层层压实责任，实现端到端全程闭环管控。以全链条自主可控的坚实能力，确保交付品质与托底保障万无一失。</p>
            <p style="font-size: 16px;">平台面向优质设计机构、装企等企业服务商，以及设计师、造价师、项目经理、工人等个人服务商全面开放，共同服务城乡多元空间更新需求。</p>
          </div>
        </div>

        <div class="about-section-title about-values-title">
          <p class="intro-en">MISSION VISION VALUES</p>
          <h2 class="intro-title">使命愿景价值观</h2>
          <div class="intro-line"></div>
        </div>

        <div class="about-values">
          <article class="about-value-item">
            <h3>我们的使命</h3>
            <p>重塑产业信任，让每一次服务都值得托付</p>
          </article>
          <article class="about-value-item">
            <h3>我们的愿景</h3>
            <p>成为广大用户信赖的百年企业</p>
          </article>
          <article class="about-value-item">
            <h3>我们的价值观</h3>
            <p>客户至上、实事求是、正直诚信、追求卓越</p>
          </article>
        </div>

        <div class="about-meaning">
          <div class="about-section-title">
            <p class="intro-en">NAME MEANING</p>
            <h2 class="intro-title">化化名字的寓意</h2>
            <div class="intro-line"></div>
          </div>
          <div class="about-meaning-card">
            <p>《周易》贲卦、彖传：“<strong>刚柔交错，天文也；文明以止，人文也。观乎天文，以察时变；观乎人文，以化成天下。</strong>”</p>
            <p>中华文化上下五千年不断，有着非常强大的民族向心力，东西文化相比，中国文化强调人的主体性、独立性、能动性及中华之“士”的精神，不是靠一个外在的神或造物主，而是靠人的自觉与自律，这是中国文化的核心。</p>
            <p>“化化”要传达的就是这种文化核心，这是第一个“化”的意思，第二个化是“化解、化成”之义，只要遵照第一个“化”，我们相信任何纠纷、问题都能化解，任何梦想都能化成现实，这也是我们搭建这个平台的意义。</p>
          </div>
        </div>
      </div>
    </section>

    <section id="img-3" class="contact-section">
      <div class="about-section-title contact-title">
        <p class="intro-en">CONTACT US</p>
        <h2 class="intro-title">联系我们</h2>
        <div class="intro-line"></div>
      </div>
      <div class="contact-map">
        <img class="contact-map-img" src="https://obs.huahuaeco.com/official/About/concatUsMap.png" alt="联系我们地图" />
      </div>
    </section>
    <SeoStaticImages :images="seoImages" />
  </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { getPageHead } from '../utils/page-head'
import SeoStaticImages from '../components/SeoStaticImages.vue'
export default {
  name: 'SettleInPage',
  components: {
    SeoStaticImages
  },
    setup() {
    useHead(getPageHead('about'))
  },
  data() {
    return {
      seoImages: [
        'https://obs.huahuaeco.com/official/aboutTopBg.png',
        'https://obs.huahuaeco.com/official/About/huahuaCompany.png',
        'https://obs.huahuaeco.com/official/About/BigIntroduction.png',
        'https://obs.huahuaeco.com/official/About/concatUsMap.png'
      ]
    }
  },
  methods: {
     
  }
  ,
  mounted() {
  },
  beforeUnmount() {
  }
}
</script>

<style scoped lang="scss">
.hero {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
  height: 480px;
  width: 100%;
  overflow: hidden;
  .texts {
    position: absolute;
    top: 2rem;
    z-index: 9;
    text-align: center;
    padding: 0 50px;
    font-weight: 600;
    .hero-1 {
      font-size: .6rem;
      color: #fff;
      margin-bottom: 12px;
    }
    .hero-2 {
      font-size: .4rem;
      color: #fff;
      margin-top: 30px;
    }
  }
  &-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    z-index: 0;
    pointer-events: none;
  }

  &-title {
    position: relative;
    z-index: 1;
    max-width: 1008px;
    width: 100%;
    height: auto;
    display: block;
  }
}
/* .content{}
.bg1{background-image:url('https://obs.huahuaeco.com/official/About/bg1.png');height: 900px;background-size:cover;background-position:center;padding-top: 80px;z-index: 77;}
.bg1 div{z-index: 88;}
.bg2{background-image:url('https://obs.huahuaeco.com/official/About/bg2.png');height: 1080px;background-size:cover;background-position:center;margin-top: -700px;z-index: 66;} */

.full-image {
  width: 100%;
  display: block;
  height: inherit !important;
  &-img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }
}

#img-2 {
  background-image: url('https://obs.huahuaeco.com/official/About/BigIntroduction.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.about-intro {
  max-width: 1100px;
  margin: 0 auto;
  padding: 30px 16px 48px;
}

.intro-top {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 34px;
  align-items: start;
}

.intro-cover {
  width: 100%;
  height: auto;
  border-radius: 22px;
  display: block;
}

.intro-main {
  color: #3a3a3a;
  p {
    margin: 0 0 10px;
    color: #595959;
    font-size: 18px;
    line-height: 1.5;
  }
}

.intro-en {
  margin: 0;
  color: #BFBFBF !important;
  font-size: 20px;
  line-height: 1.3;
  letter-spacing: 0.4px;
}

.intro-main p.intro-en {
  margin: 0;
  font-size: 20px;
  line-height: 1.3;
}

.intro-title {
  margin: 4px 0 8px;
  color: #262626;
  font-size: 32px;
  line-height: 1.3;
}

.intro-line {
  width: 30px;
  height: 2px;
  background: #2b78ff;
  margin-bottom: 14px;
}

.about-section-title {
  text-align: center;
  .intro-line {
    margin-left: auto;
    margin-right: auto;
  }
}

.about-values-title {
  margin-top: 26px;
}

.about-values {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.about-value-item {
  background: rgba(255, 255, 255, 0.76);
  border-radius: 12px;
  padding: 16px 12px;
  text-align: center;
  box-shadow: 0 8px 14px 0 rgba(224, 229, 238, 0.50);
  h3 {
    margin: 0;
    color: #262626;
    font-size: 22px;
    font-weight: 400 !important;
  }

  p {
    margin: 8px 0 0;
    color: #8c8c8c;
    font-size: 16px;
    line-height: 1.6;
  }
}

.about-meaning {
  margin-top: 100px;
}

.about-meaning-card {
  margin-top: 18px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.72);
  padding: 18px 20px;
  text-align: center;
  box-shadow: 0 20px 40px 0 rgba(224, 229, 238, 0.20);
  p {
    margin: 0 0 10px;
    color: #595959;
    font-size: 16px;
    line-height: 1.8;
  }

  p:last-child {
    margin-bottom: 0;
  }
}

.contact-section {
  background: #f5f8fc;
  padding: 38px 16px 58px;
}

.contact-title {
  margin-bottom: 28px;
}

.contact-map {
  width: 100%;
  max-width: 1190px;
  margin: 0 auto;
}

.contact-map-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

@media (max-width: 900px) {
  .intro-top {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .intro-cover {
    max-width: 320px;
    margin: 0 auto;
  }

  .intro-en {
    font-size: 14px;
  }

  .intro-main p.intro-en {
    font-size: 14px;
  }

  .intro-title {
    font-size: 28px;
  }

  .intro-main p {
    font-size: 14px;
  }

  .about-values {
    grid-template-columns: 1fr;
  }

  .about-value-item h3 {
    font-size: 22px;
  }

  .about-value-item p {
    font-size: 14px;
  }

  .about-meaning {
    margin-top: 26px;
  }

  .contact-section {
    padding: 30px 16px 38px;
  }

  .contact-title {
    margin-bottom: 18px;
  }

  .about-meaning-card p {
    font-size: 14px;
  }
}

</style>
